// extracted by mini-css-extract-plugin
export default {"container":"SystemInformation_container__RCLiu","title":"SystemInformation_title__lqCMQ","loader":"SystemInformation_loader__MOLHm"};